import { Components, Theme } from '@mui/material/styles';

export const getTabs = (
  app: 'kc' | 'rti',
): {
  MuiTabs: Components<Theme>['MuiTabs'];
  MuiTab: Components<Theme>['MuiTab'];
} => ({
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: 'unset',
        borderBottom: '1px solid #E6E6E6',

        '.MuiTabs-flexContainer': { gap: '20px' },
        '.MuiTabs-indicator': { height: '4px' },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body2,
        color: theme.palette.customColors.tabColor,
        height: '34px',
        minHeight: 'unset',
        minWidth: 'unset',
        padding: 0,
        justifyContent: 'flex-start',

        ...(app === 'rti' && {
          '&:hover': {
            color: theme.palette.primary.light,
          },
        }),

        // Selected tab is not clickable (no button effects), but not disabled.
        // kc keeps MUI default selected color (primary.main = gold).
        // rti forces dark text so the indicator does the visual work.
        '&.Mui-selected': {
          pointerEvents: 'none',
          ...(app === 'rti' && { color: theme.palette.text.primary }),
        },
      }),
    },
  },
});

export default getTabs;
